/**
 * Demo Mode Configuration
 *
 * Set REACT_APP_DEMO_MODE=true in .env to enable demo mode
 * Default: true (demo mode enabled)
 * Set to 'false' for full features
 */

// Check if demo mode is enabled (defaults to true)
export const isDemoMode = process.env.REACT_APP_DEMO_MODE !== 'false';

// Demo mode feature flags
export const DEMO_CONFIG = {
  // Landing page - where to start
  landingPage: '/explore',

  // Features to hide/disable in demo mode
  features: {
    // More Actions menu items
    bookmark: false,
    loadBookmark: false,
    loadAll: false,

    // Controls to hide
    videoStitcher: false,
    hideGenericCheckbox: false,
    newestFirstCheckbox: false,
    filterByRound: false,

    // New features in demo
    showThoughtsToggle: true,

    // Header changes
    showSpaceNameAsHeader: true,

    // Other potential restrictions
    createNewSpace: false,
    customizeSpace: false,
  }
};

// Helper to check if a feature is enabled
export const isFeatureEnabled = (featureName) => {
  if (!isDemoMode) return true; // All features enabled when not in demo mode
  return DEMO_CONFIG.features[featureName] ?? true;
};

// Premium features — disabled in v1, returning later as paid features.
// Unlike DEMO_CONFIG.features (which only restricts during demo mode),
// these gates apply in ALL modes. To re-enable for testing, flip the value
// here. To wire up per-user premium logic later, replace the boolean with
// a check at the call sites.
export const PREMIUM_FEATURES = {
  // Per-space AI desktop agent ("Bot Vision" tab).
  // Disabled in v1 in favor of "Claude the Explorer" (the homepage roaming bot).
  // Call sites: pages/GameStepPage.js — tab definition (~line 28506) and panel render (~line 28816).
  botVision: false,
};

export const isPremiumFeatureEnabled = (featureName) => {
  return PREMIUM_FEATURES[featureName] ?? false;
};

// Log demo mode status on load
if (typeof window !== 'undefined') {
  console.log('[Demo Config] Demo mode:', isDemoMode ? 'ENABLED' : 'DISABLED');
}
